import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../../services/productservice';
import { FifaSubscrieService } from '../../../services/fifaSubscrie.service';
import { Product } from '../../../services/product';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthenticationService } from '@app/auth/authentication.service';
import { NavigationEnd, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Carousel } from 'primeng/carousel';
import { TranslateService } from '@ngx-translate/core';
import { PageStateService } from '../../../services/pageStateService';
const GALLERY = 'gallery';
const CAT_TESTIMONIAL: string = 'destination';

@Component({
  selector: 'app-legacy-footer',
  templateUrl: './legacy-footer.component.html',
  styleUrls: ['./legacy-footer.component.scss'],
  providers: [MessageService],
})
export class LegacyFooterComponent implements OnInit {
  products: Product[];
  responsiveOptions: any;
  footerSocialLinks: any;
  footerMenuApps: any;
  footerLogo: any = { name: null, url: null, icon: null };
  footerMenu: any;
  footerMobileMenu: any;
  subscribeEmail: FormGroup;
  subscribeEmailDialogue: boolean;
  subscribeRes: Object;
  testimonialResponsive: any;
  public subscribeMessage: string;
  islandsFooter: any = { name: null, children: null };
  experienceFooter: any = { name: null, children: null };
  footerMainMenu: any = { name: null, children: null };
  footerTCPrivacy: any;
  TestMonialData: any[] = [];
  homePage = true;

  constructor(
    private productService: ProductService,
    private messageService: MessageService,
    private authenticationService: AuthenticationService,
    private formBuilder: FormBuilder,
    private router: Router,
    private translate: TranslateService,
    public pageStateService: PageStateService,
    private FifaSubscrieService: FifaSubscrieService
  ) {
    Carousel.prototype.onTouchMove = () => {};
    this.responsiveOptions = [
      {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 1,
      },
      {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '560px',
        numVisible: 1,
        numScroll: 1,
      },
    ];

    this.testimonialResponsive = [
      {
        breakpoint: '1024px',
        numVisible: 1,
        numScroll: 1,
      },
      {
        breakpoint: '768px',
        numVisible: 1,
        numScroll: 1,
      },
      {
        breakpoint: '640px',
        numVisible: 1,
        numScroll: 1,
      },
      {
        breakpoint: '480px',
        numVisible: 1,
        numScroll: 1,
      },
    ];
    this.createSubscribeForm();
  }
  footerData: any;
  ngOnInit(): void {
    this.checkTestimonialDisplay();
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.checkTestimonialDisplay();
      }
    });
    this.FifaSubscrieService.emailSubscribeDialogObservable$.subscribe(() => {
      this.showEmailSubscribeDialog();
    });
    this.productService.getFooterLogo().then((result) => {
      this.footerLogo = result[0];
    });
    //this.getTestiMonial();
    this.productService.getFooterMainMenu().then((result) => {
      this.footerMainMenu = result[0];
      this.islandsFooter = result[1];

      this.experienceFooter = result[2];
      if (this.experienceFooter.children) {
        this.experienceFooter.children.forEach((item: any) => {
          if (item.name === 'Sustainability') {
            // item.name = 'Sustainability';
            // item.url = '/special_interest/sustainability';
            item.url = '/special_interest/sustainable_seychelles';
          }
        });
      }
    });

    this.productService.getFooterSocialNW().then((result) => {
      this.footerSocialLinks = result;
      Array.from(this.footerSocialLinks).map((data: any) => {
        if (data.name === 'Facebook') {
          data.icon = data.icon.substr(0, data.icon.indexOf('_'));
        }
      });
    });

    this.productService.getFooterAppStores().then((result) => {
      this.footerMenuApps = result;
    });

    this.productService.getFooterMenu().then((result) => {
      //console.log(result);
      result.forEach((item: any) => {
        if (item.url.indexOf('downloads') > -1) {
          item.url = '/downloads';
        }
      });
      this.products = <Product[]>result;
    });

    this.productService.getFooterResponsive().then((result) => {
      this.footerMobileMenu = <Product[]>result;
    });
    this.productService.getFooterTCPrivacy().then((result) => {
      this.footerTCPrivacy = result;
    });
  }
  checkTestimonialDisplay() {
    if (window.location.href.indexOf('special_interest') > -1) {
      this.homePage = false;
    } else {
      this.homePage = true;
    }
  }
  getTestiMonial() {
    try {
      this.productService.getTestiMonial().then((res) => {
        this.TestMonialData = res.filter(
          (item: any) => item.field_special_intrest.toLowerCase() === CAT_TESTIMONIAL.toLowerCase()
        );
      });
    } catch (error) {}
  }
  showEmailSubscribeDialog() {
    this.subscribeEmailDialogue = true;
  }
  closeEmailSubscribeDialog() {
    //window.location.reload();
    this.subscribeEmailDialogue = false;
  }
  subscribe(email: any) {
    this.authenticationService.Usersubscribe(email).then((res) => {
      this.subscribeRes = res;
      if (this.subscribeRes) {
        this.messageService.add({
          key: 'subscribe',
          severity: 'success',
          summary: this.translate.instant('Success'),
          detail: this.translate.instant('Subscribed successfully'),
        });
        setTimeout(() => {
          this.subscribeEmailDialogue = false;
        }, 2000);
        //this.subscribeMessage = 'Subscribed successfully';
      }
    });
  }

  private createSubscribeForm() {
    this.subscribeEmail = this.formBuilder.group({
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            "^$|^([\\w-']+(?:\\.[\\w-']+)*)@((?:[\\w-]+\\.)*\\w[\\w-]+)\\.([a-zA-Z]+(?:\\.[a-zA-Z]+)?)$"
          ),
        ],
      ],
    });
  }
}
